import { Component, OnInit, Input } from '@angular/core';
import { Ticket } from '@fgb/core';
import { TicketQuery } from '@fgb/core';
import { map, Observable, of } from 'rxjs';
import { TicketService, TicketDetails } from '@fgb/core';

@Component({
  selector: 'fgbcl-selected-tickets-table',
  templateUrl: './selected-tickets-table.component.html',
  styleUrls: ['./selected-tickets-table.component.scss'],
})
export class SelectedTicketsTableComponent implements OnInit {
  selectedTickets$: Observable<Ticket[]>;
  @Input() showRemoveButton: boolean = false;
  @Input() ticket: Ticket | undefined = undefined;
  @Input() ticketColumn1: TicketDetails = TicketDetails.Area;
  @Input() ticketColumn2: TicketDetails = TicketDetails.Stand;
  hasRow$: Observable<boolean>;
  ticketDetails = TicketDetails;

  constructor(private ticketQuery: TicketQuery, private ticketService: TicketService) {}

  ngOnInit() {
    if (this.ticket === undefined) {
      this.selectedTickets$ = this.ticketQuery.selectedTickets();
    } else {
      this.selectedTickets$ = of([this.ticket]);
    }

    this.hasRow$ = this.selectedTickets$.pipe(map(tickets => tickets.some(ticket => !!ticket.Row)));
  }

  remove(id: string) {
    this.ticketService.removeSelectedTicket(id);
  }
}
